import React from "react";

const SafariAutofillMessage = ({ ...props }) => {
    const { setSafariAutoFillInfoHandler } = props;
    return (
        <div className="alert astm-alert bg-info--light" role="alert" data-testid='safari-message'>
            <span className="astm-alert-text">We are assuming that Autofill settings are turned on for Safari browser (Safari {">"} Preferences {">"} AutoFill). Please turn off the settings for the best site experience or use a different browser.</span>
            <button type="button" data-testid='btn' onClick={() => setSafariAutoFillInfoHandler(false)} className="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true"><i className="astm-icon far fa-times"></i></span>
            </button>
        </div>
    )
}

export default SafariAutofillMessage;
